export default __webpack_public_path__ + "static/media/i060jk.7ff51d9c.webp";